import VueWrapper from '@/components/core/Vue/vue.wrapper';
import Component from 'vue-class-component';
import {BackupService} from '../services/backup.service';
import BackupFilePreviewDialogComponent from './backup-file-preview-dialog.component';

@Component({
    components: {
        BackupFilePreviewDialogComponent,
    },
})
export default class BackupHistoryComponent extends VueWrapper {
    public $refs!: {
        backupFilePreviewDialogRef: BackupFilePreviewDialogComponent;
    };

    public userId: string | null = null;

    public showPreviewDialog: boolean = false;
    public previewContent: string = '';

    public backupSrv: BackupService = new BackupService();

    public createBackup() {
        this.backupSrv.createBackup();
    }

    public downloadBackup(backup: any) {
        this.backupSrv.downloadBackup(backup);
    }

    public deleteBackup(backup: any) {
        this.backupSrv.deleteBackup(backup);
    }

    public viewBackup(backup: any) {
        this.previewContent = backup.name;
        this.$refs.backupFilePreviewDialogRef.open();
    }
}
